export const SLASH_KEY = 'slash-key';
